export enum PaymentMethod {
    bkash_bdt = "bkash_bdt",
    nagad_bdt = "nagad_bdt",
    vasl = 'vasl',
    avangard_pos = 'avangard_pos',
    pay_to_phone_emu = 'pay_to_phone_emu',
    multitransfer = 'multitransfer',
    whitebird = 'whitebird',
    one_label = 'one_label',
    beeline = 'beeline',
    mts = 'mts',
    mts_mobile = 'mts_mobile',
    qr_manager = 'qr_manager',
    qris_idr = 'qris_idr',
}